import { parseAsInteger, useQueryStates } from 'nuqs'

const DEFAULT_PAGE_INDEX = 0
const DEFAULT_PAGE_SIZE = 50

export const usePagination = ({
  defaultPageIndex = DEFAULT_PAGE_INDEX,
  defaultPageSize = DEFAULT_PAGE_SIZE,
}: { defaultPageIndex?: number; defaultPageSize?: number } = {}) => {
  const [pagination, setPagination] = useQueryStates(
    {
      pageIndex: parseAsInteger.withDefault(defaultPageIndex),
      pageSize: parseAsInteger.withDefault(defaultPageSize),
    },
    {
      urlKeys: {
        pageIndex: 'page-number',
        pageSize: 'page-size',
      },
      history: 'push',
    }
  )

  return {
    pagination,
    onPaginationChange: ({ pageIndex, pageSize }: { pageIndex: number; pageSize: number }) => {
      setPagination(prev => {
        // If the page size changes, reset pageIndex to defaultPageIndex
        if (pageSize !== prev.pageSize) {
          return { pageIndex: defaultPageIndex, pageSize }
        }
        return { pageIndex, pageSize }
      })
    },
    resetPageIndex: () => {
      setPagination(prev => ({ ...prev, pageIndex: defaultPageIndex }))
    },
  }
}
